// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-recommendation-title[data-v-ce79254c]{text-transform:none;color:#fff;font-size:28px;line-height:32px;font-weight:700;margin-block-end:24px;display:flex;justify-content:space-between;align-items:center}.text-recommendation-container[data-v-ce79254c]{container-type:inline-size}", ""]);
// Exports
module.exports = exports;
